import { notification } from 'antd';

import ValidateCadenciaError from '../handlers/ValidateCadenciaError';
import ValidateVolumeError from '../handlers/ValidateVolumeError';
import { removeThousandSeparatorMask } from './formatador';

export const stepsFields = (clientePerfil, userId) => {
  const fields = [
    [
      'nomeUsuario',
      'loginUsuario',
      'celUsuario',
      'emailUsuario',
      'cpfUsuario',
      'lograUsuario',
      'cidadeUsuario',
      'bairroUsuario',
      'estadoUsuario',
      'cepUsuario',
    ],
    ['idCliente'],
    [],
    [],
  ];

  if (!clientePerfil) {
    fields.splice(1, 1); // Remove validação do step InfoCliente
  }

  if (!userId) {
    fields[0].push(...['strongPass', 'passConfirm']);
  }

  return fields;
};

export const validatePass = ({ password, passwordConfirm, isValidPass }) => {
  if (password || passwordConfirm) {
    if (!isValidPass) {
      notification.warning({
        message: 'Algo de errado aconteceu',
        description: 'A senha deve respeitar os critérios estabelecidos.',
      });
      return false;
    }

    if (password !== passwordConfirm) {
      notification.warning({
        message: 'Algo de errado aconteceu',
        description: 'As senhas devem ser idênticas.',
      });
      return false;
    }
  }

  return true;
};

export const validateEmail = email => {
  const regExp = /\S+@\S+\.\S+/;

  if (!regExp.test(email)) {
    notification.warning({
      message: 'Algo de errado aconteceu',
      description: 'O email não possui um formato válido.',
    });
    return false;
  }
  return true;
};

export const validateEmailFormat = email => {
  const regExp = /\S+@\S+\.\S+/;

  return regExp.test(email);
};

export const validateLogin = login => {
  const regExp = /^[^\\:]*$/;

  if (!regExp.test(login)) {
    notification.warning({
      message: 'Algo de errado aconteceu',
      description: 'O login não possui um formato válido. Tire os dois pontos',
    });
    return false;
  }
  return true;
};

export const validateClientesPagadores = ({
  cliente,
  clientesSecundarios,
  clientesPagadores,
}) => {
  const clientesCnpjResumido = [...cliente, ...clientesSecundarios].map(
    ({ cnpj_resumido }) => cnpj_resumido
  );

  const clientesPagadoresValidos = clientesPagadores.filter(({ cnpj }) => {
    const pagadorCnpjResumido = cnpj.substr(0, 8);

    return clientesCnpjResumido.includes(pagadorCnpjResumido);
  });

  if (clientesPagadoresValidos.length === clientesPagadores.length) return true;

  return notification.warning({
    message: 'Algo de errado aconteceu',
    description:
      'Os clientes pagadores selecionados estão em desacordo com o cliente matriz selecionado.',
  });
};

export const validatePermissions = selectedPermissions => {
  if (selectedPermissions.length === 0) {
    notification.warning({
      message: 'Algo de errado aconteceu',
      description: 'Selecione pelo menos uma permissão.',
    });
    return true;
  }
  return false;
};

export const validateForm = (current, userId, form, clientePerfil) => {
  const fields = stepsFields(clientePerfil, userId);
  const fieldsValue = form.getFieldsValue(fields[current]);
  const values = Object.values(fieldsValue);

  // Tornar campos de endereço opcionais para preenchimento
  values.splice(5, 5);

  return values.filter(value => !value).length !== 0;
};

export const isCpfValid = cpf => {
  let cpfValidado;

  // Validar se é String
  if (typeof cpf !== 'string') return false;

  // Tirar formatação
  cpfValidado = cpf.replace(/[^\d]+/g, '');

  // Validar se tem tamanho 11 ou se é uma sequência de digitos repetidos
  if (cpfValidado.length !== 11 || !!cpfValidado.match(/(\d)\1{10}/)) {
    return false;
  }

  // String para Array
  cpfValidado = cpfValidado.split('');

  const validator = cpfValidado
    // Pegar os últimos 2 digitos de validação
    .filter((digit, index, array) => index >= array.length - 2 && digit)
    // Transformar digitos em números
    .map(el => +el);

  const toValidate = pop =>
    cpfValidado
      // Pegar Array de items para validar
      .filter((digit, index, array) => index < array.length - pop && digit)
      // Transformar digitos em números
      .map(el => +el);

  const rest = (count, pop) =>
    ((toValidate(pop)
      // Calcular Soma dos digitos e multiplicar por 10
      .reduce((soma, el, i) => soma + el * (count - i), 0) *
      10) %
      // Pegar o resto por 11
      11) %
    // transformar de 10 para 0
    10;

  return !(rest(10, 2) !== validator[0] || rest(11, 1) !== validator[1]);
};

export const validateCadencia = (cadencia, volume) => {
  let cadenciaFormated = cadencia;
  let volumeFormated = volume;

  if (typeof cadencia === 'string') {
    cadenciaFormated = removeThousandSeparatorMask(cadencia);
  }

  if (typeof volume === 'string') {
    volumeFormated = removeThousandSeparatorMask(volume);
  }

  if (!cadenciaFormated || volumeFormated >= cadenciaFormated) {
    return Promise.resolve();
  }

  return Promise.reject(
    new ValidateCadenciaError('A cadência não pode ser maior que o volume!')
  );
};

export const validateCadenciaMovimentado = async (
  cadencia,
  cadenciaMovimentada,
  setIsvalid = () => {}
) => {
  let cadenciaFormated = cadencia;

  if (typeof cadencia === 'string') {
    cadenciaFormated = removeThousandSeparatorMask(cadencia);
  }

  if (!cadenciaFormated || cadenciaFormated > cadenciaMovimentada) {
    setIsvalid(true);
    return Promise.resolve();
  }
  setIsvalid(false);
  return Promise.reject(
    new ValidateCadenciaError(
      'Por favor, insira uma cadência maior que a movimentada!'
    )
  );
};

export const validateVolumeMovimentado = (
  volume,
  volumeMovimentado,
  setIsvalid = () => {}
) => {
  let volumeFormated = volume;

  if (typeof volume === 'string') {
    volumeFormated = removeThousandSeparatorMask(volume);
  }

  if (!volumeFormated || volumeFormated > volumeMovimentado) {
    setIsvalid(true);
    return Promise.resolve();
  }
  setIsvalid(false);
  return Promise.reject(
    new ValidateVolumeError(
      'Por favor, insira um volume maior que o movimentado!'
    )
  );
};
